(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-avora-reward-card-page]');
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var scrubbed = false;
    ['code', 'amount', 'minimum', 'expires'].forEach(function (key) {
      if (!params.has(key)) return;
      params.delete(key);
      scrubbed = true;
    });
    if (scrubbed && window.history && window.history.replaceState) {
      var query = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    }

    initTierRunway(root);
    initReveals(root);
    initCardInteraction(root);

  }

  function initTierRunway(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-reward-tier]'));
    var detail = root.querySelector('[data-reward-tier-detail]');
    var ladder = root.querySelector('.avora-reward-card-page__reward-ladder');
    var track = root.querySelector('.avora-reward-card-page__reward-ladder-track');
    if (!buttons.length || !detail) return;

    function revealTier(button, smooth) {
      if (!track || track.scrollWidth <= track.clientWidth) return;
      var target = button.offsetLeft - ((track.clientWidth - button.offsetWidth) / 2);
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      track.scrollTo({ left: Math.max(0, Math.min(maximum, target)), behavior: smooth ? 'smooth' : 'auto' });
    }

    function selectTier(button, moveFocus) {
      var selectedIndex = buttons.indexOf(button);
      if (selectedIndex < 0) return;

      buttons.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      setText(detail, '[data-reward-tier-threshold]', 'Spend ' + button.dataset.threshold);
      setText(detail, '[data-reward-tier-wallet]', button.dataset.wallet);
      setText(detail, '[data-reward-tier-card]', button.dataset.card);
      setText(detail, '[data-reward-tier-minimum]', button.dataset.minimum);
      setText(detail, '[data-reward-tier-copy]', button.dataset.detail);

      var cardWrap = detail.querySelector('[data-reward-tier-card-wrap]');
      var hasCard = !!button.dataset.card;
      if (cardWrap) cardWrap.hidden = !hasCard;
      detail.classList.toggle('is-wallet-only', !hasCard);
      detail.dataset.activeTier = String(selectedIndex + 1);
      detail.setAttribute('aria-labelledby', button.id);
      detail.setAttribute('aria-label', 'Reward milestone ' + (selectedIndex + 1) + ' of ' + buttons.length);
      if (ladder) ladder.style.setProperty('--reward-ladder-progress', (((selectedIndex + 1) / buttons.length) * 100) + '%');

      replayClass(detail, 'is-changing', 560);
      window.requestAnimationFrame(function () { revealTier(button, moveFocus); });
      if (moveFocus) button.focus({ preventScroll: true });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () { selectTier(button, false); });
      button.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = buttons.length - 1;
        else return;
        event.preventDefault();
        selectTier(buttons[nextIndex], true);
      });
    });

    selectTier(root.querySelector('[data-reward-tier].is-active') || buttons[buttons.length - 1], false);
  }

  function initReveals(root) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-reward-reveal]'));
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }

    root.classList.add('has-reveal');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    nodes.forEach(function (node) { observer.observe(node); });
  }

  function initCardInteraction(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-reward-tilt]'));
    if (!cards.length || !window.matchMedia) return;

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!canHover.matches || reduceMotion.matches) return;

    cards.forEach(bindCard);

    function bindCard(card) {
      var bounds;
      var frame;
      var pointerX = 0;
      var pointerY = 0;

      card.addEventListener('pointerenter', function (event) {
        bounds = card.getBoundingClientRect();
        card.classList.add('is-hovered');
        updatePointer(event);
      });
      card.addEventListener('pointermove', updatePointer);
      card.addEventListener('pointerleave', resetCard);
      card.addEventListener('blur', resetCard);

      function updatePointer(event) {
        if (!card.classList.contains('is-hovered')) return;
        if (!bounds) bounds = card.getBoundingClientRect();
        pointerX = Math.max(-1, Math.min(1, ((event.clientX - bounds.left) / bounds.width) * 2 - 1));
        pointerY = Math.max(-1, Math.min(1, ((event.clientY - bounds.top) / bounds.height) * 2 - 1));
        if (frame) return;
        frame = window.requestAnimationFrame(renderCard);
      }

      function renderCard() {
        frame = 0;
        card.style.setProperty('--reward-rotate-x', (-pointerY * 3.5).toFixed(2) + 'deg');
        card.style.setProperty('--reward-rotate-y', (pointerX * 5).toFixed(2) + 'deg');
        card.style.setProperty('--reward-light-x', ((pointerX + 1) * 50).toFixed(1) + '%');
        card.style.setProperty('--reward-light-y', ((pointerY + 1) * 50).toFixed(1) + '%');
      }

      function resetCard() {
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        bounds = null;
        card.classList.remove('is-hovered');
        card.style.removeProperty('--reward-rotate-x');
        card.style.removeProperty('--reward-rotate-y');
        card.style.removeProperty('--reward-light-x');
        card.style.removeProperty('--reward-light-y');
      }
    }
  }

  function replayClass(node, className, duration) {
    window.clearTimeout(node._avoraClassTimer);
    node.classList.remove(className);
    void node.offsetWidth;
    node.classList.add(className);
    node._avoraClassTimer = window.setTimeout(function () { node.classList.remove(className); }, duration);
  }

  function setText(scope, selector, value) {
    var nodes = scope.querySelectorAll(selector);
    nodes.forEach(function (node) { node.textContent = value; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
